import * as React from 'react';

const InfoCircle16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8 4a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5A.75.75 0 0 1 8 12M8 1.5c3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5A6.51 6.51 0 0 1 1.5 8c0-3.584 2.916-6.5 6.5-6.5M7 5a1 1 0 1 1 2 0 1 1 0 1 1-2 0",
    clipRule: "evenodd"
  }
));
InfoCircle16.Size = 16;
InfoCircle16.Title = "InfoCircle";

export { InfoCircle16 as default };
